import { TenantBaseApi } from "api/TenantSlug/TenantBaseApi.ts";

import GetExternalFinalPageSettingsRequest = App.Http.Requests.ExternalFinalPageSetting.GetExternalFinalPageSettingsRequest;
import GetExternalFinalPageSettingsResponse = App.Http.Responses.ExternalFinalPageSetting.GetExternalFinalPageSettingsResponse;
import GetExternalFinalPageSettingRequest = App.Http.Requests.ExternalFinalPageSetting.GetExternalFinalPageSettingRequest;
import GetExternalFinalPageSettingResponse = App.Http.Responses.ExternalFinalPageSetting.GetExternalFinalPageSettingResponse;
import StoreExternalFinalPageSettingRequest = App.Http.Requests.ExternalFinalPageSetting.StoreExternalFinalPageSettingRequest;
import UpdateExternalFinalPageSettingRequest = App.Http.Requests.ExternalFinalPageSetting.UpdateExternalFinalPageSettingRequest;

class ExternalFinalPageSettingsApi extends TenantBaseApi {
    async index(offerId: string, request: GetExternalFinalPageSettingsRequest): Promise<GetExternalFinalPageSettingsResponse> {
        return await this.get<GetExternalFinalPageSettingsResponse, GetExternalFinalPageSettingsRequest>(
            `/offers/${offerId}/external-final-page-settings`,
            { params: request }
        );
    }

    async show(offerId: string, externalFinalPageSettingId: string, request: GetExternalFinalPageSettingRequest): Promise<GetExternalFinalPageSettingResponse> {
        return await this.get<GetExternalFinalPageSettingResponse, GetExternalFinalPageSettingRequest>(
            `/offers/${offerId}/external-final-page-settings/${externalFinalPageSettingId}`,
            { params: request }
        );
    }

    async store(offerId: string, request: StoreExternalFinalPageSettingRequest): Promise<GetExternalFinalPageSettingResponse> {
        return await this.post<GetExternalFinalPageSettingResponse, StoreExternalFinalPageSettingRequest>(
            `/offers/${offerId}/external-final-page-settings`,
            request
        );
    }

    async update(offerId: string, externalFinalPageSettingId: string, request: UpdateExternalFinalPageSettingRequest): Promise<GetExternalFinalPageSettingResponse> {
        return await this.put<GetExternalFinalPageSettingResponse, UpdateExternalFinalPageSettingRequest>(
            `/offers/${offerId}/external-final-page-settings/${externalFinalPageSettingId}`,
            request
        );
    }

    async destroy(offerId: string, externalFinalPageSettingId: string): Promise<void> {
        return await this.delete(`/offers/${offerId}/external-final-page-settings/${externalFinalPageSettingId}`);
    }
}

export const externalFinalPageSettingsApi = new ExternalFinalPageSettingsApi();